<template>
  <div style="width: 100%; height: 100%">
    <div
      class="list-banner index-top-banner"
      :style="{
        backgroundImage: 'url(' + domData.customField1 + ')',
      }"
    >
      <div class="w1200 animate_top index-top-box">
        <div class="index-top-left">
          <a class="index-btn">
            {{
              domData.customField2
                ? domData.customField2.text
                : childItem.propsValue.buttonInfo.text
            }}
          </a>
        </div>
        <div
          class="index-form"
          v-if="domData.customField3 && domData.customField3.form"
        >
          <div class="index-form-box">
            <h3>获取数智化解决方案</h3>
            <div class="option">
              <div>
                <span class="required-xing">*</span>
                <span>手机号</span>
              </div>
              <div>
                <input
                  id="sem-from-phone"
                  type="text"
                  placeholder="请输入手机号"
                  class="inp"
                />
              </div>
              <div></div>
            </div>
            <div class="option">
              <div></div>
              <div>
                <input
                  autocomplete="off"
                  type="text"
                  placeholder="短信验证码"
                  class="phone_testnum"
                />
                <p class="phone_test_p">获取验证码</p>
              </div>
            </div>
            <button class="index-form-btn">获取数智化解决方案</button>
            <div class="index-form-tick">
              <img src="../../../../../assets/img/tickh.png" alt />
              <p>
                我已阅读并了解
                <span>《隐私政策》</span>；您所填写的信息已进行安全加密。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  buttonObject,
  formObject,
} from "@/modules/autoweb/config/elementObject.js";
let buttonObjectTemp = _.cloneDeep(buttonObject);
buttonObjectTemp.text = "获取数智化解决方案";
let formObjectTemp = _.cloneDeep(formObject);
export default {
  name: "MkBannerWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    domData: function () {
      return this.childItem.propsValue.data instanceof Array
        ? this.childItem.propsValue.data[0]
        : this.childItem.propsValue.data;
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 1920,
          height: 640,
        },
        {
          code: "customField2",
          label: "按钮",
          type: "button",
        },
        {
          code: "customField3",
          label: "表单",
          type: "form",
        },
      ],
      data: [
        {
          customField1:
            "https://mks.yybip.com/group1/M00/01/04/CgoRDGLzDayABr2oAAlP1QVyuZM506.jpg",
          customField2: _.cloneDeep(buttonObjectTemp),
          customField3: _.cloneDeep(formObjectTemp),
        },
      ],
    };
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.index-top-banner {
  height: 100%;
  background-size: auto 100% !important;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  .index-top-box {
    overflow: hidden;
  }
  .index-top-left {
    width: 440px;
    padding-top: 224px;
    padding-left: 100px;
    float: left;
    a.index-btn {
      display: block;
      width: 140px;
      height: 28px;
      line-height: 28px;
      color: #ffffff;
      font-size: 12px;
      text-align: center;
      background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
      border-radius: 6px;
    }
    a:hover.index-btn {
      background-image: linear-gradient(-131deg, #e5732d 0%, #e31924 52%);
    }
  }

  .index-form {
    float: right;
    margin-top: 75px;
    margin-right: 25px;
    width: 320px;
    background: url(../../../../../assets/img/form-bg.png) #fff no-repeat top
      right;
    box-shadow: 0 4px 8px 0 rgba(175, 175, 175, 0.1);
    border-radius: 6px;
    font-size: 12px;

    .index-form-box {
      padding: 24px;
      h3 {
        line-height: 22px;
        font-size: 18px;
        color: #e61318;
        font-weight: 700;
        text-align: center;
        padding-bottom: 16px;
        margin: 0 auto;
      }
      .option {
        width: 100%;
        height: 28px;
        margin-top: 7px;
        position: relative;
        transition: all 1s;
        > div:nth-child(1) {
          width: 23%;
          height: 100%;
          line-height: 26px;
          text-align: right;
          padding-right: 9px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          float: left;
          align-items: center;
          span {
            font-size: 12px;
            color: #333333;
            line-height: 16px;
            font-weight: 500;
          }
          .required-xing {
            color: #e60012 !important;
            margin-right: 5px;
          }
        }
        > div:nth-child(2) {
          width: 77%;
          height: 100%;
          position: relative;
          float: left;
          display: flex;
          input {
            background: #ffffff;
            width: 100%;
            font-size: 12px;
            height: 100%;
            text-indent: 16px;
            border: 1px solid rgba(221, 221, 221, 1);
            border-radius: 4px;
            outline: none;
          }
          .phone_testnum {
            width: 60% !important;
            border-radius: 4px 0 0 4px !important;
            float: left;
          }
          .phone_test_p {
            width: 40%;
            height: 28px;
            background: #e14c46;
            float: right;
            color: #fff;
            line-height: 38px;
            justify-content: center;
            align-items: center;
            display: flex;
            border-radius: 0 4px 4px 0;
            cursor: pointer;
            margin: 0;
          }
          .check {
            display: none;
            color: #e60012;
          }
        }
      }
      .checkboxs {
        height: 130px;
        > div:nth-child(1) {
          width: 100%;
          height: 30px;
          text-align: left;
        }
      }
      .checkboxStyle {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;
        padding-left: 0 !important;
        label {
          text-align: center;
          display: flex;
          margin: 0 4px 4px 0;
          justify-content: center;
          align-items: center;
          background: #ffffff;
          border-radius: 1px;
          border: 1px solid #979797;
          color: #777777;
          font-size: 14px;
        }
      }
      .textarea {
        width: 95%;
        margin-top: 10px;
        /* height: 50px; */
        height: 28px;
        > div:nth-child(1) {
          width: 100%;
          height: 30px;
          text-align: left;
          span {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            font-weight: 500;
          }
        }
        > div:nth-child(2) {
          width: 100%;
        }
        textarea {
          /* width: 100%; */
          width: 378px;
          height: 45px;
          font-size: 14px;
          border-radius: 4px;
          border: 1px solid #979797;
          padding: 5px 0 0 20px;
          outline: none;
        }
      }
      .index-form-btn {
        width: 100%;
        height: 34px;
        background-image: linear-gradient(135deg, #e97528 0%, #e90713 100%);
        border-radius: 4px;
        font-size: 16px;
        color: #ffffff;
        font-weight: 500;
        text-align: center;
        border: none;
        margin-top: 20px;
      }
      .index-form-btn:hover {
        background: #cc0817;
      }
      .index-form-tick {
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-top: 10px;
        > img {
          width: 36px;
          height: 36px;
          margin: 0 auto;
        }
        > p {
          font-size: 10px;
          color: #777777;
          font-weight: 400;
          margin: 0 auto;
          > span {
            color: #e14c46;
          }
        }
      }
    }
  }
}
</style>
